export default "__VITE_ASSET__B1lhfd2s__"